import gql from "graphql-tag";
import { VARIANT_FRAGMENT } from "@src/pages/Cart/queries";

export const AVAILABILITY_FRAGMENT = gql`
  fragment availability on ProductAvailability {
    available
    isOutOfStock
    onSale
    priceRange {
      start {
        gross {
          amount
        }
      }
    }
  }
`;

export const PRODUCT_FOR_ADD_TO_CART = gql`
  ${AVAILABILITY_FRAGMENT}
  ${VARIANT_FRAGMENT}
  fragment productForAddToCart on Product {
    id
    name
    isPublished
    publicationDate
    productType {
      id
      name
      isCodRestricted
      hasVariants
      isMgs
    }
    category {
      id
      name
    }
    availability {
      ...availability
    }
    variants {
      ...variant
    }
    price {
        currency
        amount
    }
    thumbnailForQuickShop: thumbnail(size:540) {
        url
        alt
    }
  }
`;

export const PRODUCT_THUMBNAIL = gql`
  ${PRODUCT_FOR_ADD_TO_CART}
  fragment productThumbnail on Product {
    ...productForAddToCart
    url
    urlForGraphql
    brand
    video
    isOnWishlist
    popularity
    publicationDate
    productReviewsAggregation {
      id
      rating
      reviewCount
    }
    thumbnail {
      url
      alt
    }
    hasFreebieEvent
    hasVoucher
    brandLink {
      id
    }
    images {
      id
      url(size: 255)
    }
    availableVouchers {
      discountValueType,
      discountValue,
    }
  }
`;

export const MOBILE_PRODUCT_THUMBNAIL = gql`
  ${PRODUCT_FOR_ADD_TO_CART}
  fragment mobileProductThumbnail on Product {
    ...productForAddToCart
    url
    urlForGraphql
    brand
    video
    isOnWishlist
    popularity
    publicationDate
    productReviewsAggregation {
      id
      rating
      reviewCount
    }
    thumbnail {
      url
      alt
    }
    hasFreebieEvent
    hasVoucher
    brandLink {
      id
    }
    additionalInfo {
      wishlistCount
    }
    availableVouchers {
      discountValueType,
      discountValue,
    }
  }
`;
